import type { RouteLocationNormalized } from 'vue-router'
import type { RouteGuard, GuardResult } from './RouteGuard'

export class RequiresStudentGuard implements RouteGuard {
  name = 'requiresStudent'

  // ADR-SEC-014 de quizoteca-admin (2026-06-13; no es el ADR-SEC-014 local de este repo,
  // que es App Check): el acceso al portal es por autenticación + ownership, NO por rol. La data ya está protegida en firestore.rules por identidad
  // (uid == student_id) y por participación-ownership (classroom_students/{cid}_{uid}),
  // de forma role-agnóstica. Bloquear por rol 'student' a nivel de app impedía que un
  // profesor-participante (un profesor que tomó un curso como estudiante) entrara al
  // portal a ver su nota/retroalimentación. El gate de rol se retira; cualquier usuario
  // autenticado pasa (RequiresAuthGuard ya cubre la autenticación).
  canActivate(_to: RouteLocationNormalized): GuardResult {
    return true
  }
}
